import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthorisedSubNavLink } from '../../Auth/AuthorisedSubNavLink';
import { SubNavProps } from '../SubNavLinks';

const AssetsSubNav: React.FC<SubNavProps> = props => {
  const { t } = useTranslation('designs');

  useEffect(() => {
    props.setHeading(t('label'));
  });

  const hasSite = props.clientId && props.level === 'sites';

  return (
    <>
      {hasSite ? (
        <>
          <AuthorisedSubNavLink
            permissions={['ManageTemplates']}
            to={`/${props.level}/${props.clientId}/designs/templates/email`}
            icon="mail-bulk"
            label={t('nav.designGallery.email')}
          />
          <AuthorisedSubNavLink
            permissions={['ManageTemplates']}
            to={`/${props.level}/${props.clientId}/designs/templates/sms`}
            icon="mobile"
            label={t('nav.designGallery.sms')}
          />
          <AuthorisedSubNavLink
            permissions={['ManageTemplates']}
            featureFlag="ld-rcs"
            to={`/${props.level}/${props.clientId}/designs/templates/rcs`}
            icon="mobile"
            label={t('nav.designGallery.rcs')}
          />
          <AuthorisedSubNavLink
            permissions={['ManageTemplates']}
            to={`/${props.level}/${props.clientId}/designs/templates/onsite`}
            icon="mail-bulk"
            label={t('nav.designGallery.onsite')}
          />
          <AuthorisedSubNavLink
            permissions={['ManageTemplates']}
            featureFlag={'ld-mps-template'}
            to={`/${props.level}/${props.clientId}/designs/templates/mps`}
            icon="mail-bulk"
            label={t('nav.designGallery.mps')}
          />
          <AuthorisedSubNavLink
            permissions={['ManageTemplates']}
            featureFlag={'ld-archiving'}
            to={`/${props.level}/${props.clientId}/designs/templates/archive`}
            icon="archive"
            label={t('nav.designGallery.archive')}
          />
          <AuthorisedSubNavLink
            permissions={['ManageAssets']}
            to={`/${props.level}/${props.clientId}/designs/asset-management`}
            icon="photo-video"
            label={t('nav.assetManagement')}
          />
        </>
      ) : (
        <>
          <AuthorisedSubNavLink
            permissions={['ManageAssets']}
            to={`/designs/asset-management`}
            icon="photo-video"
            label={t('nav.assetManagement')}
          />
        </>
      )}
    </>
  );
};

export default AssetsSubNav;
